import type { SVGProps } from "react"

export function CatIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3.1-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z" />
      <path d="M8 14v.5" />
      <path d="M16 14v.5" />
      <path d="M11.25 16.25h1.5L12 17l-.75-.75Z" />
    </svg>
  )
}

export function FishIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z" />
      <path d="M18 12v.5" />
      <path d="M16 17.93a9.77 9.77 0 0 1 0-11.86" />
      <path d="M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33" />
    </svg>
  )
}

export function HamsterIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 17a2 2 0 0 1-2-2v-1a3 3 0 0 1 3-3h1" />
      <path d="M20 17a2 2 0 0 0 2-2v-1a3 3 0 0 0-3-3h-1" />
      <path d="M12 19a4 4 0 0 1-4-4V8a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v7a4 4 0 0 1-4 4Z" />
      <path d="M8 15v1" />
      <path d="M16 15v1" />
      <path d="M12 13v1" />
      <path d="M10 8v1" />
      <path d="M14 8v1" />
    </svg>
  )
}

export function LizardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 14c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Z" />
      <path d="M19 17.5c-1.4-1-3.1-1.5-5-1.5-3.9 0-7 1.3-7 3" />
      <path d="M19 11.5c-1.4 1-3.1 1.5-5 1.5-3.9 0-7-1.3-7-3" />
      <path d="M14.5 6.5c-3.3-3.3-5.2-1.5-6.5 0-1.3 1.5-2 3-2 5.5 0 2.4.7 3.9 2 5.5 1.3 1.5 3.2 3.3 6.5 0" />
      <path d="M9.5 6.5c3.3-3.3 5.2-1.5 6.5 0 1.3 1.5 2 3 2 5.5 0 2.4-.7 3.9-2 5.5-1.3 1.5-3.2 3.3-6.5 0" />
    </svg>
  )
}

